/**
 * Formats an area value for display without changing the source value.
 * API payloads may contain numeric strings despite their TypeScript contracts.
 */
export function formatSquareFeet(
  value: number | string | null | undefined,
): string | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  const numericValue = typeof value === 'number' ? value : Number(value.trim());
  if (!Number.isFinite(numericValue)) {
    return undefined;
  }

  return new Intl.NumberFormat(undefined, {
    maximumFractionDigits: 1,
  }).format(numericValue);
}
